import { combineReducers } from 'redux';
import authReducer from './Auth/AuthSlice';

const rootReducer = combineReducers({
    auth: authReducer,
});

export default rootReducer;
